var chunkToChildrenMap = {
	"1911": [
		5450,
		6773,
		7488
	],
	"3773": [
		5450,
		6773,
		7488
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));